/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Coaches_Week_ShowInputs */

const en_portal_coaches_week_show = /** @type {(inputs: Portal_Coaches_Week_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show every time this week`)
};

const pl_portal_coaches_week_show = /** @type {(inputs: Portal_Coaches_Week_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż wszystkie terminy w tym tygodniu`)
};

/**
* | output |
* | --- |
* | "Show every time this week" |
*
* @param {Portal_Coaches_Week_ShowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_coaches_week_show = /** @type {((inputs?: Portal_Coaches_Week_ShowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Coaches_Week_ShowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_coaches_week_show(inputs)
	return en_portal_coaches_week_show(inputs)
});